import { Button } from 'react-frontier';
import { CDN_URL } from '../AuthAPI';

var Privacy = () => {
    return (
        <div style={{ 
            minHeight: '100vh', 
            backgroundColor: '#', 
            backgroundImage: 'radial-gradient(at 50% 0%, #f3f4f6 0px, transparent 50%)',
            fontFamily: "'Inter', 'Roboto', sans-serif",
            paddingBottom: 80 
        }}>
            <div style={{ 
                height: 70, 
                backgroundColor: '#402312', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                padding: '0 30px',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <a style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={`${CDN_URL}/static/logo/Logo_White.png`} alt="COCOAN" style={{ height: 28 }} />
                </a>
            </div>

            <div style={{ 
                maxWidth: 720, 
                margin: '60px auto 0', 
                backgroundColor: '#ffffff', 
                borderRadius: 24, 
                padding: '60px 70px', 
                boxShadow: '0 20px 40px -15px rgba(0,0,0,0.05), 0 0 10px rgba(0,0,0,0.01)',
                border: '1px solid #f0f0f0',
                color: '#333'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 50 }}>
                    <div style={{ 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        width: 72, 
                        height: 72, 
                        borderRadius: '50%', 
                        backgroundColor: '#fafafa', 
                        border: '1px solid #eee',
                        color: '#111',
                        marginBottom: 24
                    }}>
                        <i className="shield alternate icon" style={{ fontSize: 32, margin: 0, color: '#333' }} />
                    </div>
                    <h1 style={{ fontSize: 36, fontWeight: 800, margin: 0, color: '#111', letterSpacing: '-0.02em' }}>Aviso de Privacidad</h1>
                    <p style={{ color: '#888', marginTop: 12, fontSize: 15, fontWeight: 500 }}>Última actualización: 2026</p>
                </div>

                <div style={{ 
                    fontSize: 16, 
                    lineHeight: 1.8, 
                    color: '#4b5563',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 24
                }}>
                    <p>En <strong style={{ color: '#111' }}>Cocoan Chocolatería</strong>, valoramos y protegemos la privacidad de nuestros clientes. Los datos personales que nos proporcione, como nombre, teléfono, correo electrónico, dirección de envío y datos de facturación, serán utilizados para procesar sus pedidos, gestionar el envío de productos, emitir comprobantes fiscales, brindar atención al cliente y dar seguimiento a sus compras.</p>
                    
                    <div style={{ 
                        padding: '24px 30px', 
                        backgroundColor: '#f8fafc', 
                        borderRadius: 12, 
                        borderLeft: '4px solid #402312' 
                    }}>
                        <p style={{ margin: 0, color: '#334155' }}>De manera adicional, y únicamente con su consentimiento, podremos utilizar sus datos para enviar información sobre promociones, novedades y campañas comerciales. Usted podrá solicitar en cualquier momento dejar de recibir este tipo de comunicaciones.</p>
                    </div>

                    <p>Sus datos personales únicamente podrán ser compartidos con proveedores que intervengan en el procesamiento de pagos, servicios de mensajería o cuando exista una obligación legal para ello.</p>
                    
                    <p>Usted podrá ejercer sus derechos de <strong style={{ color: '#111' }}>Acceso, Rectificación, Cancelación y Oposición (ARCO)</strong>, así como solicitar información sobre el tratamiento de sus datos personales, mediante los medios de contacto que se publiquen en este sitio.</p>
                    
                    <p>Nuestro sitio web puede utilizar cookies y tecnologías similares para mejorar la experiencia de navegación y obtener información estadística sobre el uso del sitio.</p>
                    
                    <p>Cualquier modificación al presente Aviso de Privacidad será publicada oportunamente en este mismo sitio web.</p>
                </div>

                <div style={{ marginTop: 60, paddingTop: 40, borderTop: '1px solid #f1f5f9', textAlign: 'center' }}>
                    <Button color="black" text="Cerrar pestaña" size="small" onClick={() => window.close()} />
                </div>
            </div>
        </div>
    )
}

export default Privacy;
